<script>

    export default {
        name: 'pageAbout',
        layout: 'default',

        components: {},

        data: () => {
            return {}
        }
    }
</script>

<template>
    <div class="about-us row">
        <section class="container what-we-do">
            <div class="row">
                <div class="col-md-5 col-xs-12 col-sm-12 media-block">
                    <img src="images/ss_build-business.png" alt="Построение бизнеса" media-simple="true"/>
                </div>
                <div class="col-md-7 col-xs-12 col-sm-12">
                    <h1 class="title">SportService</h1>
                    <h2 class="sub-title">
                        Это удобная и проста платформа с широким спектром возможностей, который упростит и решит все задачи, возникающие в ходе работы Фитнес Центра. Ваши сотрудники смогут начать полноценную работу с сервисом уже в течении нескольких минут, благодаря максимально простому и удобному интерфейсу.</h2>
                </div>
            </div>
        </section>

        <section class="container our-mission">
            <div class="row">
                <div class="col-md-7 col-xs-12 col-sm-12">
                    <h1 class="title">Наша миссия</h1>
                    <h2 class="sub-title">
                        Автоматизировать ведение Вашего бизнеса и предоставить возможность контролировать его на расстоянии.
                    </h2>
                </div>
                <div class="col-md-5 col-xs-12 col-sm-12 media-block">
                    <img src="images/ss_our_mission.png" alt="Наша миссия" media-simple="true"/>
                </div>
            </div>
        </section>

        <!--<section class="w-100 our-leaders ">-->
        <!--<div class="container">-->
        <!--<div class="row">-->
        <!--<div class="col-md-4 col-xs-12 col-sm-12 media-block">-->
        <!--<img src="images/our-leaders.png" alt="Наши лидеры" class="img-thumbnail" media-simple="true"/>-->
        <!--</div>-->
        <!--<div class="col-md-8 col-xs-12 col-sm-12">-->
        <!--<h1 class="title">Встречайте наших лидеров</h1>-->
        <!--<h2 class="sub-title">Команда - определяет движении компании. <br>Мы стараемся уделять особое внимание подбору персонала.-->
        <!--</h2>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</section>-->

        <section class="container our-mission">
            <div class="row mission-header">
                <div class="col-md-5 col-xs-12 col-sm-12 media-block">
                    <img src="images/our-values.png" alt="Наши ценности" media-simple="true"/>
                </div>
                <div class="col-md-7 col-xs-12 col-sm-12">
                    <h1 class="title">Мы предлагаем</h1>
                    <h2 class="sub-title">
                        <ul>
                            <li>Качественную и быструю техническую поддержку</li>
                            <li>Возможность выбора разных пакетов услуг, в зависимости от масштаба Вашего бизнеса.</li>
                            <li>Гарантированное масштабирование бизнеса каждого клиента.</li>
                        </ul>
                    </h2>
                </div>
            </div>

            <!--<div class="media-container-row row">-->
                <!--<div class="col-md-6 col-xs-12 col-sm-12">-->
                    <!--<div class="media-container-row">-->
                        <!--<div class="mbr-figure"><i class="fa fa-heartbeat" aria-hidden="true"></i></div>-->
                        <!--<div class="media-content">-->
                            <!--<div class="mbr-section-text"><h1>Чесность и открытость</h1>-->
                                <!--<p class="mbr-text mb-0">-->
                                    <!--Это один из самых важных элементов, которые мы пропагируем в Компании.</p>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="col-md-6 col-xs-12 col-sm-12">-->
                    <!--<div class="media-container-row">-->
                        <!--<div class="mbr-figure"><i class="fa fa-paint-brush" aria-hidden="true"></i></div>-->
                        <!--<div class="media-content">-->
                            <!--<div class="mbr-section-text"><h1>Творческий подход к делу</h1>-->
                                <!--<p class="mbr-text mb-0">-->
                                    <!--Мы любим то, чем занимаемся. Каждый наш шаг - не моход на предыдущий.</p>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->

            <!--<div class="media-container-row row">-->
                <!--<div class="col-md-6 col-xs-12 col-sm-12">-->
                    <!--<div class="media-container-row">-->
                        <!--<div class="mbr-figure"><i class="fa fa-users" aria-hidden="true"></i></div>-->
                        <!--<div class="media-content">-->
                            <!--<div class="mbr-section-text"><h1>Мы команда</h1>-->
                                <!--<p class="mbr-text mb-0">-->
                                    <!--Мы действуем как единый организм. Каждый знает свои обязаности.</p>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="col-md-6 col-xs-12 col-sm-12">-->
                    <!--<div class="media-container-row">-->
                        <!--<div class="mbr-figure"><i class="fa fa-street-view" aria-hidden="true"></i></div>-->
                        <!--<div class="media-content">-->
                            <!--<div class="mbr-section-text"><h1>Клиент и его задачи</h1>-->
                                <!--<p class="mbr-text mb-0">-->
                                    <!--Клиенты - наша жизненная сила. Без счастливых клиентов мы обречены.</p>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->

        </section>
    </div>
</template>



// WEBPACK FOOTER //
// resources/assets/js/pages/about.vue